import { getImageCells, nextLetter } from "./functions";
import { Logos } from "./makeExcel-constants";

function colLetter(n) {
  let s = "";
  while (n > 0) {
    const m = (n - 1) % 26;
    s = String.fromCharCode(65 + m) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}

export const makeExcel = async (data, iata, base64Logo, assistRow = null, withassistanceCountsHeader = false, hideLogo = false) => {
  const Excel = await import("exceljs/dist/exceljs.min.js");
  let workSheetName = data.workSheetName;
  let workbook = new Excel.Workbook();

  // number of leading banner rows reserved for the logo (0 when the logo is hidden)
  const logoRows = hideLogo ? 0 : 1;

  workbook.views = [
    {
      x: 0,
      y: 0,
      width: 10000,
      height: 20000,
      firstSheet: 0,
      activeTab: 0,
      visibility: "visible",
    },
  ];
  let sheets = [],
    sheet;
  let workSheetImageHeader = hideLogo
    ? null
    : workbook.addImage({
        base64: base64Logo || Logos.MAIN_LOGO,
        extension: "png",
      });
  let workSheetImageHeader2 = "";
  if (!hideLogo && iata === "JDK")
    workSheetImageHeader2 = workbook.addImage({
      base64: Logos.SGS_LOGO,

      extension: "png",
    });
  let headerLetter = "A";
  for (let cw_idx = 0; cw_idx < data.columnTitles.length - 1; cw_idx++) {
    headerLetter = nextLetter(headerLetter);
  }
  for (let idx = 0; idx < workSheetName.length; idx++) {
    sheets[idx] = workbook.addWorksheet(workSheetName[idx], {
      views: [
        { state: "frozen", xSplit: 0, ySplit: logoRows + (withassistanceCountsHeader ? 2 : 1) },
        { rightToLeft: false },
      ],
    });
  }

  let dataAlignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true,
  };
  let dataBorder = { bottom: { style: "thin" }, left: { style: "thin" } };
  let columnTitles = data.columnTitles;
  let columnWidth = data.columnWidth;
  let rows = data.rows; // move rows declaration here
  sheets.map((x, i) => {
    let letter = "A";
    sheet = sheets[i];
    const headers = columnTitles[i];
    // only set column widths for the actual number of columns in the data
    // use the first row to determine the actual column count
    const firstRow = rows[i][0];
    const actualColumnCount = headers.length;

    // const actualColumnCount = firstRow ? Object.keys(firstRow).length : columnTitles[i].length;
    for (let j = 0; j < actualColumnCount; j++) {
      if (columnWidth[i][j]) {
        sheet.getColumn(letter).width = columnWidth[i][j];
      }
      letter = nextLetter(letter);
    }
    if (!hideLogo) {
      sheet.addImage(workSheetImageHeader, {
        ...getImageCells(columnTitles, 1),
        ext: { width: 500, height: 100 },
        editAs: "absolute",
      });
      if (iata === "JDK")
        sheet.addImage(workSheetImageHeader2, {
          ...getImageCells(columnTitles, 6),
          ext: { width: 500, height: 100 },
          editAs: "absolute",
        });
      sheet.mergeCells(`A1:${letter}1`);

      sheet.getRow(1).height = 90;
    }

    // row where the assistance-counts summary lives (right after any logo banner)
    const assistRowNumber = logoRows + 1;

    if (withassistanceCountsHeader && assistRow && assistRow.length) {
      // take first two items, pad the rest to match header length
      const first = assistRow[0] ?? "";
      const second = assistRow[1] ?? "";
      const padded = [first, second, ...Array(Math.max(0, actualColumnCount - 2)).fill("")];
      sheet.addRow(padded); // this becomes the assist summary row
      sheet.lastRow.alignment = dataAlignment;
      sheet.lastRow.border = dataBorder;
      sheet.lastRow.height = 22;
    }

    // only add the actual number of column titles that match the data
    const actualColumnTitles = columnTitles[i].slice(0, actualColumnCount);
    sheet.addRow(actualColumnTitles);

    sheet.lastRow.alignment = dataAlignment;
    sheet.lastRow.border = dataBorder;


    if (withassistanceCountsHeader) {
      const lastCol = colLetter(actualColumnCount);
      // Only merge if there's something in the assist row's second cell (the “BLND: x | …” cell)
      const assistLabelCell = sheet.getCell(`B${assistRowNumber}`);
      if (assistLabelCell && assistLabelCell.value) {
        sheet.mergeCells(`B${assistRowNumber}:${lastCol}${assistRowNumber}`);
        assistLabelCell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
      }
    }
    const headerRows = withassistanceCountsHeader
      ? [assistRowNumber, assistRowNumber + 1]
      : [logoRows + 1];

    // common styles
    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "E1FAF5" }, // light teal background
    };
    const headerFont = { size: 16, family: 2, color: { argb: "3B7AB4" }, bold: true };
    const bodyFont = { size: 12, family: 2 };
    const cellBorder = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    const cellAlign = { vertical: "middle", horizontal: "center", wrapText: true };

    // apply row-level header font once per header row
    headerRows.forEach(r => {
      const row = sheet.getRow(r);
      row.font = headerFont;
      row.height = row.height || 25;
    });
    sheet.eachRow((row, rowNumber) => {
      row.eachCell((cell, colNumber) => {
        // header band fill for row 2 (and row 3 when flag is on)
        if (headerRows.includes(rowNumber)) {
          cell.fill = headerFill;
        } else {
          cell.font = bodyFont;
        }

        cell.border = cellBorder;
        cell.alignment = cellAlign;

        // optional: set column-wide alignment/font too (by column!)
        const col = sheet.getColumn(colNumber);
        col.alignment = col.alignment || cellAlign;
        if (!headerRows.includes(rowNumber)) {
          col.font = col.font || bodyFont;
        }
      });
    });


    rows[i].map((x) => {
      let oneRow = [];
      let originalRow = []; // keep original data for nested detection

      // only process the actual columns that exist in the data
      const actualColumns = Object.keys(x);
      for (let field of actualColumns) {
        const cellValue = x[field];
        originalRow.push(cellValue); // keep original for nested detection

        // handle Number of Journeys column - extract value if it's an object
        if (typeof cellValue === 'object' && cellValue?.value !== undefined) {
          oneRow.push(cellValue.value);
        } else {
          oneRow.push(cellValue);
        }
      }
      sheet.addRow(oneRow);
      sheet.lastRow.height = 25;
      sheet.lastRow.alignment = dataAlignment;
      sheet.lastRow.border = dataBorder;

      // add top border to all parent cells
      sheet.lastRow.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };
      });

      // check if any cell in this row has children data (use original data)
      const hasChildrenData = originalRow.some(cell =>
        typeof cell === 'object' && cell?.childrenColumns && cell?.childrenData
      );

      // get the first cell with children data (use original data)
      const cellWithChildren = originalRow.find(cell =>
        typeof cell === 'object' && cell?.childrenColumns && cell?.childrenData
      );

      // add nested table rows if children data exists
      if (hasChildrenData && cellWithChildren) {
        // add white padding row before nested table (vertical padding) for all nested children
        const topPaddingRow = new Array(actualColumns.length).fill('');
        sheet.addRow(topPaddingRow);
        sheet.lastRow.height = 30; // Increased height for better visibility
        sheet.lastRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ffffff" }
        };

        // add header row for nested table with horizontal padding
        const nestedHeaders = cellWithChildren.childrenColumns.map(col => col.name);
        const nestedHeaderRow = new Array(actualColumns.length).fill('');

        // add nested headers with horizontal padding (first column is white, no extra last column)
        nestedHeaders.forEach((header, headerIndex) => {
          if (headerIndex + 1 < nestedHeaderRow.length) {
            nestedHeaderRow[headerIndex + 1] = header;
          }
        });

        sheet.addRow(nestedHeaderRow);
        sheet.lastRow.height = 30;
        sheet.lastRow.alignment = dataAlignment;
        sheet.lastRow.border = dataBorder;
        sheet.lastRow.font = {
          size: 12,
          family: 2,
          bold: true,
          color: { argb: "3b7ab4" } // same color as main headers
        };

        // apply different background colors and borders to different columns
        const nestedDataEnd = nestedHeaders.length + 1; // last 1-based col index with actual nested data
        sheet.lastRow.eachCell((cell, colNumber) => {
          if (colNumber === 1 || colNumber > nestedDataEnd) {
            // left padding col or any trailing cols beyond nested data: white, no borders
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "ffffff" }
            };
            cell.border = {
              top: { style: "none" },
              left: { style: "none" },
              bottom: { style: "none" },
              right: { style: "none" }
            };
          } else {
            // nested data columns: teal background with full borders
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "e1faf5" }
            };
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" }
            };
          }
        });

        // add nested data rows with horizontal padding
        cellWithChildren.childrenData.forEach((childRow, childIndex) => {
          const nestedDataRow = new Array(actualColumns.length).fill('');

          // add nested data with horizontal padding (first column is white, no extra last column)
          childRow.forEach((childCell, cellIndex) => {
            if (cellIndex + 1 < nestedDataRow.length) {
              nestedDataRow[cellIndex + 1] = childCell;
            }
          });

          sheet.addRow(nestedDataRow);
          sheet.lastRow.height = 22;
          sheet.lastRow.alignment = dataAlignment;
          sheet.lastRow.border = dataBorder;
          sheet.lastRow.font = { size: 11, family: 2 };

          // apply white background and borders to all cells in data rows
          const childrenColCount = cellWithChildren.childrenColumns.length;
          sheet.lastRow.eachCell((cell, colNumber) => {
            if (colNumber === 1 || colNumber > childrenColCount + 1) {
              // left padding col or any trailing cols beyond nested data: white, no borders
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "ffffff" }
              };
              cell.border = {
                top: { style: "none" },
                left: { style: "none" },
                bottom: { style: "none" },
                right: { style: "none" }
              };
            } else {
              // nested data columns: white background with full borders
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "ffffff" }
              };
              cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
              };
            }
          });
        });

        // add white padding row after nested table (vertical padding)
        const bottomPaddingRow = new Array(actualColumns.length).fill('');
        sheet.addRow(bottomPaddingRow);
        sheet.lastRow.height = 30; // Increased height for better visibility
        sheet.lastRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ffffff" }
        };
      }
    });

    // clean up any empty rows at the end of the sheet
    const lastRowWithData = sheet.lastRow;
    if (lastRowWithData && lastRowWithData.values && lastRowWithData.values.every(cell => !cell || cell === '')) {
      sheet.spliceRows(lastRowWithData.number, 1);
    }
  });

  let buf = await workbook.xlsx.writeBuffer();
  let xslFileName = data.fileName
    ? `${data.fileName}.xlsx`
    : `EXCEL_FILE_${new Date().getTime()}.xlsx`;

  const downloadUrl = window.URL.createObjectURL(new Blob([buf]));

  const link = document.createElement("a");

  link.href = downloadUrl;

  link.setAttribute("download", xslFileName); //any other extension

  document.body.appendChild(link);

  link.click();
  return null;
};
